import { FilterValue, filterValueFromResponse } from './FilterValue';

export interface FilterKey extends FilterValue {
  isActive: boolean;
  values: FilterValue[];
}

export const filterKeyFromResponse = (responseData: any): FilterKey => ({
  ...filterValueFromResponse(responseData),
  isActive: responseData.is_active,
  values: (responseData.values ?? []).map(filterValueFromResponse),
});
